/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IIntegrationChannel } from 'app/shared/model/integration-channel.model';
import { ITenantIntegrationEndpointAttribute } from 'app/shared/model/tenant-integration-endpoint-attribute.model';
import { ITenantIntegrationTemplate } from 'app/shared/model/tenant-integration-template.model';
import { IDataCategory } from 'app/shared/model/data-category.model';

export interface ITenantIntegrationChannel {
  id?: string;
  localName?: string | null;
  localCode?: string | null;
  tenantId?: string | null;
  tenantType?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  channel?: IIntegrationChannel | null;
  attribute?: ITenantIntegrationEndpointAttribute | null;
  template?: ITenantIntegrationTemplate | null;
  categories?: IDataCategory[] | null;
}

export const defaultValue: Readonly<ITenantIntegrationChannel> = {
  active: false,
};
